<template>
    <div class="row g-6 g-xl-9">
        <div class="col-12 col-md-12 col-xl-12">
            <Index :modal_cadastro="modal_cadastro" :perfis="perfis" :turma="turma" />
        </div>
    </div>
</template>

<script lang="ts">
import Index from "./_Index.vue"
import { Options, Vue } from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
const authStore = namespace('auth');

@Options({
    name: "QtsSemanalTab",
    components: { Index },
})
export default class QtsSemanalTab extends Vue {

    @Prop() readonly turma!: any

    @authStore.Getter
    public perfis!: any

    public modal_cadastro = 'kt_cadastrar_qts_semanal';
}
</script>
